(function () {
  var path = window.location && window.location.pathname ? window.location.pathname : "";
  if (path.indexOf("/example/debug-console") === -1) {
    return;
  }

  var suffix = " (You found the hidden log. Keep exploring Synticore examples.)";
  var references = [
    "The cake is a lie.",
    "Hello, World. It still works.",
    "There is no spoon, only semicolons.",
    "You have discovered the debug panel side quest.",
    "Welcome to Costco, I love you.",
    "In the beginning there was nothing, then npm install happened.",
    "It works on my machine.",
    "Ship it.",
    "I, for one, welcome our new linting overlords.",
    "sudo make me a sandwich.",
    "There are only two hard things in Computer Science: cache invalidation and naming things.",
    "To understand recursion, you must first understand recursion.",
    "Talk is cheap. Show me the code.",
    "It's not a bug, it's an undocumented feature.",
    "One does not simply deploy on Friday.",
    "rm -rf / is not a shortcut.",
    "May the source be with you.",
    "Y U NO SHIP CLEAN CODE?",
    "Keep calm and clear cache.",
    "Did you try turning it off and on again?",
    "The code must flow.",
    "So long, and thanks for all the fish.",
    "Open the pod bay doors, HAL.",
    "Winter is coming. Add tests.",
    "Great Scott, this compiled at 88 miles per hour.",
    "Never tell me the odds. Ship the patch.",
    "I know kung fu... grep.",
    "No place like 127.0.0.1.",
    "404: Motivation not found.",
    "You are in a maze of twisty little code paths, all alike.",
    "Beware of heisenbugs: they vanish when observed.",
    "Left pad remembers.",
    "Tabs vs spaces: choose your fighter.",
    "Merge conflicts build character.",
    "Trust, but verify.",
    "If it hurts, do it more often."
  ];

  function randomReference() {
    return references[Math.floor(Math.random() * references.length)];
  }

  function emitEasterEgg() {
    console.info("[Easter Egg] " + randomReference() + suffix);
  }

  window.setTimeout(function () {
    emitEasterEgg();
    window.setInterval(emitEasterEgg, 60000);
  }, 15000);
})();
